import { MaterialSymbols_500Medium } from '@expo-google-fonts/material-symbols/500Medium';

import type { AndroidSymbolWeight } from '../..';
const weight: AndroidSymbolWeight = {
  name: 'MaterialSymbols_500Medium',
  font: MaterialSymbols_500Medium,
};
export default weight;
